import React from "react";
import { openSignUrl } from "../../../utils/HelperFunction";
import { Link } from "react-router-dom";
import {
  EMPLOYEE_TYPE,
  PARTNER_TYPE,
  SF_TYPE,
} from "../../../constant/status_constant";
import { toast } from "react-toastify";
import httpRequest from "../../../utils/Http";
import moment from "moment";

const MiscChargeTab = ({ miscellaneousCharge, loggedInUser, setReload }) => {
  const deleteMiscCharge = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      const data = await httpRequest("deletemisccharge/" + id, {}, "GET");
      if (data.status === true && data.message) {
        toast.success(data.message);
        setReload(true);
      } else {
        toast.error(data.message);
      }
    }
  };

  return (
    <section className="misc-charge-ledger">
      {miscellaneousCharge.length > 0 ? (
        <>
          <div className="misc-charge-ledger__header">
            <div><span>Additional services</span><h2>Miscellaneous charges</h2></div>
            <span className="misc-charge-ledger__count">{miscellaneousCharge.length} {miscellaneousCharge.length === 1 ? "item" : "items"}</span>
          </div>
          <div className="table-responsive misc-charge-ledger__table-wrap">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>SNo.</th>
                <th>Service/Product</th>
                <th>Description</th>
                {Number(loggedInUser.entity_type) !== SF_TYPE && (
                  <th>Partner Charge</th>
                )}
                {Number(loggedInUser.entity_type) !== PARTNER_TYPE && (
                  <th>ASC Payout</th>
                )}
                {Number(loggedInUser.entity_type) !== SF_TYPE && (
                  <th>Approval File</th>
                )}
                {Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && (
                  <th>Purchase File</th>
                )}
                <th>Added By</th>
                {Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && (
                  <th>Delete</th>
                )}
                <th>Status</th>
                {Number(loggedInUser.entity_type) !== SF_TYPE && (
                  <>
                    <th>Approved/Rejected By</th>
                    <th>Rejection Reason</th>
                    <th>Approved/Rejected At</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {miscellaneousCharge.map((item, index) => (
                <tr key={index} className="text-center">
                  <td>{index + 1}</td>
                  <td>{item.service}</td>
                  <td>{`${item.description}`} </td>
                  {Number(loggedInUser.entity_type) !== SF_TYPE && (
                    <td>{item.partner_charge}</td>
                  )}
                  {Number(loggedInUser.entity_type) !== PARTNER_TYPE && (
                    <td>{item.sc_charge}</td>
                  )}
                  {Number(loggedInUser.entity_type) !== SF_TYPE && (
                    <td>
                      <Link
                        to={`#`}
                        onClick={() => openSignUrl(item.approval_file)}
                      >
                        View
                      </Link>
                    </td>
                  )}
                  {Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && (
                    <td>
                      {item.purchase_file && (
                        <Link
                          to={`#`}
                          onClick={() => openSignUrl(item.purchase_file)}
                        >
                          View
                        </Link>
                      )}
                    </td>
                  )}
                  <td>{item.agent_detail?.name}</td>
                  {Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && (
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => deleteMiscCharge(item.id)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </td>
                  )}
                  <td>
                    {Number(item.is_approved) === 1
                      ? "Approved"
                      : Number(item.is_approved) === 2
                      ? "Rejected"
                      : "Pending"}
                  </td>
                  {Number(loggedInUser.entity_type) !== SF_TYPE && (
                    <>
                      <td>{item?.approval_by?.name}</td>
                      <td>{Number(item.is_approved) === 2 ? item.rejection_reason : ""}</td>
                      <td>
                        {item?.approved_at
                          ? moment(item.approved_at).format("DD-MM-YYYY")
                          : ""}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </>
      ) : (
        <div className="booking-tab-empty"><i className="fas fa-receipt" aria-hidden="true" /><h3>No miscellaneous charges</h3><p>There are no additional service or product charges for this booking.</p></div>
      )}
    </section>
  );
};

export default MiscChargeTab;
